import formatAmount from '@betgames/bg-tools/dist/utils/formatAmount';
import { IStatistics } from 'twain-sport-fe-mono/interfaces';
import { StatisticsValueType } from 'twain-sport-fe-mono/enums';

const valuesWithPrecision = [StatisticsValueType.FLOAT, StatisticsValueType.PERCENTAGE];

export const formatStatisticsValue = (value: Partial<IStatistics>): string =>
    value.type !== StatisticsValueType.STRING
        ? formatAmount(Number(value.value), valuesWithPrecision.includes(value.type) ? 1 : 0)
        : (value.value as string);
